import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { PhonebookGlobalIndex } from '../shared/phonebook-custom.model';
import { BaseFormModule } from './../../../../shared/components/base/base-component/base-form.module';

@Component({
    selector: 'phonebook-global-index',
    imports: [BaseFormModule],
    templateUrl: './phonebook-global-index.component.html'
})
export class PhonebookGlobalIndexComponent {
  //#region properties
  globalFromIndex: number;
  globalCount: number;
  _isValid: boolean = false;
  @Output() globalIndexChange = new EventEmitter<PhonebookGlobalIndex>();
  @Output() isValid = new EventEmitter<boolean>();
  //#endregion

  checkIsValidGlobalIndex() {
    try {
      if (+this.globalCount && +this.globalFromIndex) this._isValid = true;
      else this._isValid = false;

      this.emitGlobalIndex();
    } catch (error) {
      console.log(
        `${PhonebookGlobalIndexComponent.name}-${this.checkIsValidGlobalIndex.name} `
      );
    }
  }

  emitGlobalIndex() {
    if (this._isValid) this.isValid.emit(true);
    else this.isValid.emit(false);
    if(this.globalFromIndex as any==='')this.globalFromIndex=undefined;
    if(this.globalCount as any==='')this.globalCount=undefined;
    this.globalIndexChange.emit({
      count: +this.globalCount,
      fromIndex: +this.globalFromIndex,
    });
  }
}
